import { configureStore } from "@reduxjs/toolkit";
import journeyReducer from "./journeySlice";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { getStoredApplicationNumber, getStoredCaseId } from "../common/utils";
import { resolveJourneyApplicationNumbers } from "../common/utils/journeyEncryption";
import { combineReducers } from "redux";

const storedAppRaw = getStoredApplicationNumber();
const storedAppResolved = storedAppRaw
  ? resolveJourneyApplicationNumbers(storedAppRaw)
  : { plain: null, encrypted: null };

const journeyInitialState = {
  currentStage: "lead",
  applicationNumber: storedAppResolved.plain || null,
  applicationNumberEncrypted: storedAppResolved.encrypted || null,
  apiCache: {},
  journeyData: null,
  caseId: getStoredCaseId() || null,
  leadResult: null,
  quoteInitResult: null,
  quoteResult: null,
  premiumResult: null,
  premiumLoading: false,
  premiumLoadingCount: 0,
  premiumError: null,
  leadFormData: null,
  multiDimensionPremiumResult: null,
  multiDimensionByPlan: null,
  quoteRiders: { selectedIds: [], covers: {} },
  quoteOptions: {
    premiumRefundEnabled: false,
    enhancedCoverageEnabled: false,
  },
  customerVerificationData: null,
  paymentFlowMode: null,
  formDefinition: null,
  stepData: {},
  proposalData: null,
  documents: {},
  pincodeTermPlanAvailability: null,
};

const rootReducer = combineReducers({
  journey: journeyReducer,
});

const stripTransientJourneyFields = createTransform(
  (inboundState) => ({
    ...inboundState,
    premiumLoading: false,
    premiumLoadingCount: 0,
    premiumError: null,
  }),
  (outboundState) => ({
    ...outboundState,
    premiumLoading: false,
    premiumLoadingCount: 0,
    premiumError: null,
  }),
  { whitelist: ["journey"] },
);

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["journey"], // persist only journey
  transforms: [stripTransientJourneyFields],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.DEV,
  preloadedState: {
    journey: journeyInitialState,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export default store;